<template>
  <section class="content">
    <div>
      <div
        class="upload-appicon upload-appicon-information-noicon"
        :title="formData.appicon ? 'Upload app icon' : 'Edit'"
      >
        <i class="fa fa-plus" v-if="!formData.appicon"></i>
        <input type="file" :disabled="isUploading" @change="uploadfile($event)" />
      </div>
      <img
        v-if="formData.appicon"
        title="APP icon"
        class="information-appicon"
        name="appicon"
        v-bind:src="'https://d.din.bz/'+formData.appicon"
      />
    </div>

    <!--<div class="upload-appicon" title="upload app icon" name="appicon" v-model="formData.appicon">-->
    <!--<i class="fa fa-plus"></i>-->
    <!--<input id="uploadicon" type="file" :disabled="isUploading" @change="uploadfile($event)"/>-->
    <!--</div>-->

    <div class="upload-progress-bar" v-show="progress > 0">
      <div class="progress progress-xxs active">
        <div
          class="progress-bar progress-bar-success progress-bar-striped"
          role="progressbar"
          :aria-valuenow="progress"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="'width: ' + progress + '%'"
        >
          <span class="sr-only">{{progress}}% Complete</span>
        </div>
      </div>
    </div>

    <div class="information-content">
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>APP ID</label>
        <input
          type="text"
          class="form-control"
          placeholder="Text"
          v-model="formData.appid"
          disabled
        />
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>APP Keys</label>
        <input
          type="text"
          class="form-control"
          placeholder="App Keys"
          v-model="formData.appkeys"
          disabled
        />
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>APP Secret</label>
        <input
          type="text"
          class="form-control"
          placeholder="App Secret"
          v-model="formData.appsecret"
          disabled
        />
      </div>
      <div class="form-group">
        <label>
          APP Name
          <em>*</em>
        </label>
        <input
          type="text"
          :disabled="!isAdmin"
          name="appname"
          class="form-control"
          placeholder="Suggest fill out the client app name"
          v-model="formData.appname"
          required
        />
      </div>
      <div class="form-group">
        <label>
          OEM Name
          <em>*</em>
        </label>
        <input
          type="text"
          :disabled="!isAdmin"
          name="oemname"
          class="form-control"
          placeholder="OEM name"
          v-model="formData.oemname"
          required
        />
      </div>
      <div class="form-group">
        <label>Description</label>
        <input
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="Description"
          name="description"
          v-model="formData.description"
        />
      </div>
      <div class="form-group">
        <label>Auto-reply email account</label>
        <input
          type="text"
          :disabled="!isAdmin"
          name="appemail"
          class="form-control"
          placeholder="Email Account"
          style="margin-bottom:5px;"
          v-model="formData.appemail"
        />
        <input
          type="text"
          :disabled="!isAdmin"
          name="appemailpassword"
          class="form-control"
          placeholder="Password"
          v-model="formData.appemailpassword"
        />
      </div>
      <div class="form-group">
        <label>About us</label>
        <input
          type="text"
          :disabled="!isAdmin"
          name="aboutme"
          class="form-control"
          placeholder="URL"
          v-model="formData.aboutme"
        />
      </div>
      <div class="form-group">
        <label>A website for jumping to after verifying the verification email to show the binding process is successful</label>
        <input
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="URL"
          v-model="formData.confirmemail"
        />
      </div>
      <div class="form-group">
        <label>Help</label>
        <input
          type="text"
          :disabled="!isAdmin"
          name="helpurl"
          class="form-control"
          placeholder="URL"
          v-model="formData.helpurl"
        />
      </div>
      <div class="form-group">
        <label>User privacy policy</label>
        <input
          type="text"
          :disabled="!isAdmin"
          name="policy"
          class="form-control"
          placeholder="URL"
          v-model="formData.policy"
        />
      </div>
      <div class="form-group">
        <label>Contact ID</label>
        <input
          type="text"
          :disabled="!isAdmin"
          name="contactid"
          class="form-control"
          placeholder="Contact ID Key"
          v-model="formData.contactid"
        />
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>SMS Config</label>
        <textarea
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="{}"
          name="smsconf"
          v-model="formData.smsconfString"
        ></textarea>
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>jPush Config</label>
        <textarea
          :disabled="!isAdmin"
          name="jpushconf"
          class="form-control"
          placeholder="{}"
          v-model="formData.jpushconfString"
        ></textarea>
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>Mail Config</label>
        <textarea
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="{}"
          name="mailconf"
          v-model="formData.mailconfString"
        ></textarea>
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>
          Feedback Mail
          <em>*</em>
        </label>
        <input
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="Feedbackmail"
          name="feedbackmail"
          v-model="formData.feedbackmail"
          required
        />
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>Allowips</label>
        <textarea
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="Allowips"
          name="allowips"
          v-model="formData.allowipsString"
        ></textarea>
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>Shareside</label>
        <input
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="Shareside"
          name="shareside"
          v-model="formData.shareside"
        />
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>Payside</label>
        <input
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="Payside"
          name="payside"
          v-model="formData.payside"
        />
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>Pay Contacts (using multiple lines for multiple contacts)</label>
        <textarea
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="Pay Contact"
          name="paycontacts"
          v-model="formData.paycontactsString"
        ></textarea>
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>
          Notification Conf
          <em>*</em>
        </label>
        <textarea
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="{}"
          name="notificationconf"
          v-model="formData.notificationconfString"
          required
        ></textarea>
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>RDA URL</label>
        <input
          type="text"
          :disabled="!isAdmin"
          class="form-control"
          placeholder="RDA URL"
          name="rdaurl"
          v-model="formData.rdaurl"
        />
      </div>
      <div class="form-group" v-if="isAppAdmin || isAdmin">
        <label>Ghome</label>
        <input
          type="checkbox"
          :disabled="!isAdmin"
          placeholder="Ghome"
          name="ghome"
          v-model="formData.ghome"
          :value="1"
        />
      </div>
    </div>
  </section>
</template>
<script>
import api from "../../api";
import utils from "../../utils";

const jsonKeys = [
  "smsconf",
  "jpushconf",
  "mailconf",
  "allowips",
  "notificationconf"
];
const arrayKeys = ["paycontacts"];

export default {
  name: "app-data-form",
  props: {
    withInitialData: Boolean
  },
  data() {
    return {
      formData: {
        appicon: "",
        appid: null,
        appname: null,
        oemname: null,
        appemail: null,
        appemailpassword: null,
        aboutme: null,
        confirmemail: null,
        helpurl: null,
        policy: null,
        contactid: null,

        description: null,
        smsconf: null,
        jpushconf: null,
        mailconf: null,
        feedbackmail: null,
        allowips: null,
        shareside: null,
        payside: null,
        paycontacts: null,
        notificationconf: null,
        rdaurl: null,
        ghome: null
      },
      progress: 0,
      isUploading: false,
      isAdmin: utils.checkIsAdmin(),
      isAppAdmin: utils.checkIsAppAdmin()
    };
  },
  methods: {
    async fetch() {
      const { appid } = this.$route.query;
      const res = await api.post({
        path: "/getappdetailbyid?_type=json",
        data: { appid },
        withLoading: true
      });
      this.formData = this._formatServerData(res);
    },
    async _save(path) {
      if (this.isUploading) {
        utils.showMsg("uploading");
        return;
      }
      const { formData } = this;
      const data = this._formatFormData(formData);
      await api.post({
        path: `/${path}?_type=json`,
        data,
        withLoading: true
      });
    },
    async update() {
      return this._save("updateappdetailbyid");
    },
    async create() {
      return this._save("addapp");
    },
    uploadfile(event) {
      if (
        !utils.isEmpty(event.target.files) &&
        !utils.isEmpty(event.target.files[0]) &&
        window.localStorage
      ) {
        this.isUploading = true;
        api.uploadFile(
          event.target.files[0],
          this.$router.app.$store.state.user.token,
          progress => {
            this.progress = progress;
          },
          (key, isOk, isCancel) => {
            this.isUploading = false;
            if (isOk) {
              this.formData.appicon = key;
            } else if (!isCancel) {
              utils.showMsg("upload fail");
            }
          }
        );
      }
    },
    _formatServerData(data) {
      jsonKeys.forEach(key => {
        if (data[key]) {
          try {
            const stringKey = `${key}String`;
            const val = data[key];
            data[stringKey] = JSON.stringify(val);
          } catch (err) {}
        }
      });
      arrayKeys.forEach(key => {
        if (data[key]) {
          try {
            const stringKey = `${key}String`;
            const val = data[key];
            if (Array.isArray(val)) {
              data[stringKey] = val.join("\n");
            }
          } catch (err) {}
        }
      });
      return data;
    },
    _formatFormData(data) {
      jsonKeys.forEach(key => {
        const stringKey = `${key}String`;
        if (data[stringKey]) {
          try {
            const val = data[stringKey];
            data[key] = JSON.parse(val);
          } catch (err) {}
        }
      });
      arrayKeys.forEach(key => {
        const stringKey = `${key}String`;
        if (data[stringKey]) {
          try {
            const val = data[stringKey];
            data[key] = val
              .replace(",", "\n")
              .split("\n")
              .map(s => s.trim());
          } catch (err) {}
        }
      });
      return data;
    }
  },
  mounted() {
    if (this.$props.withInitialData) {
      this.fetch();
    }
  }
};
</script>

<style scoped>
.information-content em {
  color: #de4444;
}
</style>



// WEBPACK FOOTER //
// AppDataForm.vue?49c82d5e